export default __webpack_public_path__ + "181fbb5fe9bebae8b2c27190a697fc97.png";